import { useMutation, useQueryClient } from '@tanstack/react-query';
import { availabilityReportService } from '@/services';
import { queryKeys } from '@/services/query-keys';
import { AvailabilityReportDetail } from '@/types';
import { logger } from '@/utils/logger';

interface UpdateItemsPayload {
  reportId: number;
  items: Array<{ id: number; quantity: number; is_deleted: boolean; counterparty_product_id?: string }>;
  creates?: Array<{ counterparty_product_id: string; symbol_id?: string; quantity: number }>;
}

type UpdateItemsOptions = {
  onSuccess?: (data: AvailabilityReportDetail) => void;
  onError?: (error: Error) => void;
};

export const useUpdateAvailabilityItems = (options?: UpdateItemsOptions) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ reportId, items, creates = [] }: UpdateItemsPayload) =>
      availabilityReportService.updateItems(reportId, items, creates),
    onSuccess: async (data, { reportId }) => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.availabilityReport.detail(reportId) });
      await queryClient.invalidateQueries({ queryKey: queryKeys.availabilityReport.list() });
      options?.onSuccess?.(data);
    },
    onError: (error: Error) => {
      logger.error('Failed to update availability report items:', error);
      options?.onError?.(error);
    },
  });
};
